/** Ethereum mainnet Tether USDT — non-standard approve requires zero-reset before increasing allowance. */
export const ETHEREUM_USDT_ADDRESS = '0xdAC17F958D2ee523a2206206994597C13D831ec7';

/** Base Sepolia USDT — same force-approve reset behavior as mainnet Tether. */
export const BASE_SEPOLIA_USDT_ADDRESS = '0x0a215d8ba66387dca84b284d18c3b4ec3de6e54a';

/** Deposit asset addresses that need approve(0) before increasing a non-zero allowance. */
export const USDT_FORCE_APPROVE_ADDRESSES: readonly string[] = [ETHEREUM_USDT_ADDRESS, BASE_SEPOLIA_USDT_ADDRESS];
